import script from "./SideNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavItem.vue?vue&type=script&setup=true&lang=js"

import "./SideNavItem.vue?vue&type=style&index=0&id=9036989c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9036989c"]])

export default __exports__